
import Component from "vue-class-component";
import {DateHelper} from '@/helpers/DateHelper';

import Vue from "vue";
import { EOrderTypes, IListOrder } from "@/model/Order/orderInterfaces";
import {Prop} from "vue-property-decorator";
import {ICell} from "@/model/Locker/lockerInterfaces";
import {IShortUser} from "@/model/shortInterfaces";
import OrderChip from "@/components/shared/chips/OrderChip.vue";

@Component({
  name: 'OrderInCellTooltip',
  components: {
  },
})
export default class OrderInCellTooltip extends Vue {
  @Prop({default: () => []})
  private lockersOrders!: IListOrder[];

  @Prop({default: () => {}})
  private cell!: ICell;

  dialogShowing: boolean = false;

  private get order(): IListOrder|undefined {
    const order: IListOrder|undefined = this.lockersOrders.find((each) => each.locker_cell_id == this.cell.id);
    return order ? order : undefined;
  }

  private get orderUser(): IShortUser|undefined {
    return this.order ? this.order.user : undefined;
  }

  private get orderServiceProvider(): any {
    if (!this.order) {
      return '';
    }

    if (this.order.service_provider) {
      return this.order.service_provider.name;
    }

    if (this.order.type == EOrderTypes.delivery_with_code) {
      this.$t('orders.order.types.delivery_with_code')
    }

    return '';
  }

  protected get orderTypeIcon(): any {
    const ret = OrderChip.chipStyleOf(this.order ? this.order.type : '');
    return ret.icon;
  }

  private get updatedAt(): string {
    return this.order && this.order.updated_at ? DateHelper.dateTimeFormat(this.order.updated_at) : '';
  }

  private get dwellTimeLabel(): string {
    if (!this.order || !this.order.created_at) {
      return '';
    }
    const ts = new Date(this.order.created_at).getTime();
    if (Number.isNaN(ts)) {
      return '';
    }
    const hours = (Date.now() - ts) / (1000 * 60 * 60);
    if (hours < 24) {
      return '';
    }
    const rounded = Math.round(hours);
    return rounded + 'h ' + this.$t('lockers.install.cells.dwellTime.' + (hours >= 72 ? 'legend72h' : 'legend24h'));
  }

  private goToOrderPage(cellId: number): object | undefined {
    const order: IListOrder|undefined = this.lockersOrders.find((each) => each.locker_cell_id == cellId);
    return order ? { name: 'order', params: {orderId: order.id}} : undefined;
  }



}
